const React = require("react");
const T = React.PropTypes;

const GlobalConstants = require("../GlobalConstants");
const ModeActionCreators = require("../actionCreators/ModeActionCreators.js");

const CubeIcon = require("./CubeIcon.jsx");

const styles = {
    Box: {
        display: "flex",
        backgroundColor: "#d21034",
        boxShadow: "0 1px 4px #444",
        textShadow: "1px 2px #a00",
        color: "#fff"
    },
    Left: {
        flex: "1 0"
    },
    Right: {
        flex: "1 0",
        paddingRight: 15,
        textAlign: "right"
    }
};

const TitleBar = React.createClass({
    propTypes: {
        Mode: T.string.isRequired
    },
    render() {
        const boxStyle = Object.assign({}, this.props.style, styles.Box);

        const nav = this.GetNav();

        return (<h1 style={boxStyle}>
            <span style={styles.Left}>
                <CubeIcon SizePx={72} Color="#fff" />
                Upload Files
            </span>
            <span style={styles.Right}>
                {nav}
            </span>
        </h1>)
    },
    GetNav() {
        const buttonStyle = {
            fontSize: 20,
            textDecoration: "underline",
            position: "relative",
            top: -5,
            background: "none",
            border: "none",
        };

        switch (this.props.Mode) {
            case GlobalConstants.Modes.History:
                const upload = GlobalConstants.Modes.Upload;

                return (<button onClick={this.GetSwitchModeTo(upload)} style={buttonStyle}>
                    Upload files
                </button>);
            default:
                const mode = GlobalConstants.Modes.History;

                return (<button style={buttonStyle} onClick={this.GetSwitchModeTo(mode)}>
                    View upload history
                </button>);
        }
    },
    GetSwitchModeTo(mode) {
        return () => {
            ModeActionCreators.SwitchTo(mode);
        };
    }
});

module.exports = TitleBar;


// WEBPACK FOOTER //
// ./src/components/TitleBar.jsx